import Block from './block';
export default Block.extend({
  isEditable: false,
  hasEditor: true,
  isNotEditable: true,
  isEmpty: false
});